import { ImageCollection } from '../../models/Image';

export default {
    namespaced: true,
    state: {
        // caches images (class Image) by id (key)
        imagesById: {},
    },
    mutations: {
        userRootAlbum(state, album) {
            state.userRootAlbum = album;
            state.loaded = true;
        },
        isLoaded(state, loaded) {
            state.loaded = loaded;
        },

        setImage(state, image) {
            let images = { ...state.imagesById };
            images[image.id] = image;
            state.imagesById = images;
        },
    },
    actions: {
        async loadImage({ commit, state }, { force = false, imageId }) {
            if (!imageId) {
                return null;
            }
            if (!state.imagesById[imageId] || force) {
                const coll = new ImageCollection();
                await coll.query({ id: imageId });
                let img = coll.first();
                if (img) {
                    commit('setImage', coll.first());
                    return img;
                }
            }
            return state.imagesById[imageId] || null;
        },
    },

    getters: {
        imageById: (state) => (id) => {
            return state.imagesById[id] || null;
        },
    },
};
